import React from "react";
import { useDispatch, useSelector } from "react-redux";
import Dash from "../../../../../../components/Math/Units/Metric/Dash";
import { RowBody } from "../../../../../../components/RowValue/RowBody";
import {
  selectKnickkoeffizient,
  setKnickkoeffizient,
} from "../../../../../../store/slices/innereSlice";
import { Trans, useTranslation } from "react-i18next";
import PlusIcon from "../../../../../../components/Icons/PlusIcon";
import ConvertToString from "../../../../../../components/Converter";

function Knicklaengenbeiwert({ show, onclick }) {
  const { t } = useTranslation("translation");

  const dispatch = useDispatch();
  const knickkoeffizient = useSelector(selectKnickkoeffizient);

  return (
    <RowBody
      titleValue={<p>{t("inner.buckling.dinEN1993.verification.bucklingCoefficient")}</p>}
      indicesValue={<span>&beta;</span>}
      inputValue={
        <select
          className="change-input"
          value={Number(knickkoeffizient)}
          onChange={(e) => dispatch(setKnickkoeffizient(e.target.value))}
        >
          <option value={0.5}>{ConvertToString("0.50", 2)}</option>
          <option value={0.7}>{ConvertToString("0.70", 2)}</option>
          <option value={1.0}>{ConvertToString("1.00", 2)}</option>
          <option value={2.0}>{ConvertToString("2.00", 2)}</option>
        </select>
      }
      unitValue={<Dash />}
      formulaValue={
        <span onClick={() => onclick(!show)}>
          <PlusIcon />
        </span>
      }
    />
  );
}

export default Knicklaengenbeiwert;
